import React from 'react';
import Link, { withPrefix } from 'gatsby-link';

import styled from 'styled-components';
import _ from 'lodash';

// Components
import Card from '../../components/Card';

const PageWrapper = styled.section``;
const Img = styled.img`width: 100%;`;


const ArchitectureWrapper = styled.section`
  display: grid;
  display: grid;
  grid-auto-rows: 1fr;
  grid-template-columns: 1fr 1fr 1fr;
  grid-column-gap: 1rem;
  position: relative;
  min-width: 1000px;
  margin: 4rem 0 0;
`;

const ArchSection = styled.div`
  height: 500px;
  position: relative;
  text-align: center;
`;

const Heading = styled.h2`
  margin: 2rem auto;
  text-align: center;
`;

const BuildList = styled.ul`
  position: absolute;
  top: 0;
  left: 0;
  height: 80%;
  margin: 20% 0 0 0;
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;

  > li {
    margin: 0 2rem;

    > label {
      padding: 1rem;
      text-align: center;
    }
  }
`;

const GatsbyListItem = styled.li`
  height: 398px;
  width: 200px;
  display: flex;
  flex-direction: row;
`;

const ReactListItem = styled.li`
  height: 398px;
  width: 100px;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;

  > label {
    margin: 1px 0;
  }
`;
const GraphQL = styled.div`
  width: 20px;
  background: black;
`;

const GatsbyLabel = styled.label`
  background: white !important;
  border: 1px dashed lightBlue;
  border-left: none;
  width: 140px;
  display: flex;
  justify-content: center;
  align-items: center;
`;

const GraphQLLabel = styled.label`
  width: 60px;
  background: hotpink;
  display: flex;
  justify-content: center;
  align-items: center;
`;


const PageTemplateLabel = styled.label`
  margin-top: 3rem !important;
  background: lightBlue;
  position: relative;
  width: 120px;

  &::after {
    content: url(${withPrefix('/images/arrow-right.svg')});
    display: block;
    position: absolute;
    right: -52px;
    top: 50%;
    width: 60px;
    margin-top: -30px;
  }

  &::before {
    content: '';
    display: block;
    position: absolute;
    left: -200px;
    top: 50%;
    height: 2px;
    width: 200px;
    background: hotpink;
    opacity: 0.5;
  }
`;

const SourcesList = styled.ul`
  position: absolute;
  top: 0;
  left: 0;
  height: 80%;
  margin: 20% 0 0 0;
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;

  > li {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 90%;
    margin: 0 auto;
    padding: 20px 10px;

    position: relative;

    &::after {
      content: url(${withPrefix('/images/arrow-right.svg')});
      display: block;
      position: absolute;
      right: -42px;
      top: 50%;
      width: 60px;
      margin-top: -30px;
    }

    > div {
      display: inline-block;
      width: 80%;
      background: lightBlue;
      padding: 1rem;
      text-align: center;

    }
    > label {
      display: inline-block;
      width: 20%;
      text-align: right;
      padding-right: 2rem;
    }
  }
`;


const PagesList = styled.ul`
  display: flex;
  flex-direction: column;
  flex-wrap: wrap;
  margin: 4rem auto;
  align-items: center;
`;

const PageItem = styled.li`
  width: 200px;
  margin: 0 0 1rem 0;
  padding: 1rem;
  border: 1px solid rgba(0, 0, 0, 0.2);
  border-right: 2px solid rgba(0, 0, 0, 0.4);
  border-bottom: 2px solid rgba(0, 0, 0, 0.4);
  border-color: ${props => props.themeColors[0]};
`;

const StandaloneArchPage = ({ data }) => {

  const grouped = _.groupBy(data.allSitePage.edges, e => e.node.context && e.node.context.type ? e.node.context.type : 'page');

  return (
    <PageWrapper>
      <h1>The Architecture</h1>
      <ArchitectureWrapper>
        <ArchSection>
          <Heading>Content</Heading>
          <SourcesList>
            <li>
              <label>Markdown (local)</label>
              <div>Nutrition Pages</div>
            </li>
            <li>
              <label>JSON (local)</label>
              <div>Config, RDA Data, Search Index</div>
            </li>
            <li>
              <label>APIs</label>
              <div><p>Foods, Diets, Nutrients</p>
              <p>(Sheets API & USDA API)</p></div>
            </li>
          </SourcesList>
        </ArchSection>
        <ArchSection>
          <Heading>Build</Heading>
          <BuildList>
            <GatsbyListItem>
              <GraphQLLabel>GraphQL</GraphQLLabel>
              <GatsbyLabel>Gatsby</GatsbyLabel>
            </GatsbyListItem>
            <ReactListItem>
              <PageTemplateLabel>NutritionPage.jsx</PageTemplateLabel>
              <PageTemplateLabel>index.js</PageTemplateLabel>
              <label>Component</label>
              <label>Component</label>
              <PageTemplateLabel>FoodPage.jsx</PageTemplateLabel>
              <label>Component</label>
              <label>Component</label>
            </ReactListItem>
          </BuildList>
        </ArchSection>
        <ArchSection>
          <Heading>Deploy</Heading>
          <PagesList>
            {_.take(grouped.food, 8).map(({ node }) => (
              <PageItem key={node.id} themeColors={node.context.content.themecolor.split('-')}>
                <Link to={node.path}>{node.path}.html</Link>
              </PageItem>
            ))}
          </PagesList>
        </ArchSection>
      </ArchitectureWrapper>
    </PageWrapper>
  );
};

export const query = graphql`
  query ArchPagesQuery {
    allSitePage {
      edges {
        node {
          id
          path
          internalComponentName
          layout
          context {
            type
            content {
              id
              title
              themecolor
              textcolor
            }
          }
        }
      }
    }
  }
`;

export default StandaloneArchPage;



// WEBPACK FOOTER //
// ./src/pages/jamstack/architecture.js